<template>
  <form @submit.prevent="save">
    <div class="nk-block">
      <div class="nk-block-head">
        <h5 class="title">Incapacidades</h5>
        <p></p>
      </div><!-- .nk-block-head -->
      <div v-if="!incapacidades.length" class="alert alert-info">
        <p>Aún no se ha añadido ningún registro, da clic en <b>Agregar Incapacidad</b> para añadir uno.</p>
      </div>
      <div v-for="incapacidad in incapacidades" :key="incapacidad.id_incapacidad" class="row">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <button v-if="!isCliente" type="button" class="btn btn-outline-danger" @click.prevent="remove(incapacidad)">Eliminar registro</button>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Motivo de la Incapacidad</label>
            <input type="text" class="form-control" v-model.lazy="incapacidad.motivo" :disabled="isCliente">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Fecha de Inicio</label>
            <input type="date" class="form-control" v-model.lazy="incapacidad.fecha" :disabled="isCliente">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Fecha de Fin</label>
            <input type="date" class="form-control" v-model.lazy="incapacidad.fecha_fin" :disabled="isCliente">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Tipo</label>
            <select v-model.lazy="incapacidad.tipo" class="form-control" :disabled="isCliente">
              <option value="1">Inicial</option>
              <option value="2">Subsecuente</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6 mt-3">
          <div class="form-group">
            <label class="form-label">Incapacidad</label>
            <Uploader :preFiles="$filters.getFiles(incapacidad.f_incapacidad?.id_archivo)" :server="$filters.getServer(model)" v-model:file="incapacidad.f_incapacidad"></Uploader>
          </div>
        </div>
      </div>
      <div class="w-100 text-right">
        <button v-if="!isCliente" type="button" class="mt-2 btn btn-lg btn-info" @click.prevent="add">Agregar Incapacidad</button>
      </div>
    </div><!-- .nk-block -->
  </form>
</template>

<script>
import {useApi} from "@/use/useApi";
import {reactive, toRefs, defineComponent, computed, watch} from 'vue';
import { useRouter } from 'vue-router';
import Swal from "sweetalert2";
import Uploader from "@/components/globales/Uploader";
const { v4: uuidv4 } = require('uuid');
import useAuth from "@/providers/auth";

export default defineComponent({
  name: "IncapacidadesEmpleado",
  props: ['empleado'],
  components: {
    Uploader
  },
  setup(params) {
    //Data
    const { loading, make } = useApi();
    const router = useRouter();
    const { isCliente } = useAuth();

    const model = computed(()=>{
      return params.empleado;
    });

    const state = reactive({
      incapacidades: [],
      inited: false
    });

    //Methods
    async function get(){
      loading.message = 'Obteniendo información';
      let {data} = await make('empleados/incapacidades/get', {id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
        router.go();
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        } else {
          state.incapacidades = data.incapacidades;
        }
      }
    }

    async function save(){
      loading.message = 'Actualizando información';
      //Save
      let {data} = await make('empleados/incapacidades/edit', {model: state.incapacidades, id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        }
      }
    }

    function add() {
      state.incapacidades.push({
        id_incapacidad: uuidv4(),
        motivo: '',
        fecha: null,
        f_incapacidad: {
          id_archivo: false,
          estatus: 'Pendiente',
          url: '#',
          autorizo: '',
          subio: '',
          nombre: ''
        }
      });
    }

    function remove(incapacidad){
      state.incapacidades = state.incapacidades.filter(_incapacidad => _incapacidad.id_incapacidad !== incapacidad.id_incapacidad);
    }

    watch(() => state.incapacidades, () => {
      if(state.inited){
        save();
      } else {
        state.inited = true;
      }
    }, {deep: true});

    get();

    return {model, ...toRefs(state), loading, save, get, add, remove, isCliente};
  }
});
</script>

<style scoped>
  textarea.form-control {
    min-height: 75px;
  }
  .form-label {
    text-transform: uppercase;
  }
</style>